export const RepeatOne = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.3129 1.66101L28.5703 6.9928L23.3318 12.2732" stroke="currentColor" stroke-width="2"/>
<path d="M8.68384 30.3221L3.42645 24.9904L8.66491 19.71" stroke="currentColor" stroke-width="2"/>
<path d="M28 7L6 7C5.44772 7 5 7.44772 5 8V15" stroke="currentColor" stroke-width="2"/>
<path d="M4 25L26 25C26.5523 25 27 24.5523 27 24L27 17" stroke="currentColor" stroke-width="2"/>
<path d="M17.2975 11V21H15.1832V13.0068H15.1246L12.8346 14.4424V12.5674L15.3102 11H17.2975Z" fill="currentColor"/>
</svg>`;
